var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '../../../../components/Button';
import { useWizard } from '../../../../hooks/useWizard';
import FadeIn from '../../../../components/Animation/FadeIn';
import Heading from '../../../../components/Typography/Heading';
import { useValidation } from '../../../../hooks/useValidation';
import { useForm } from 'react-hook-form';
import FormRow from '../../../../components/Form/Row';
import TextInput from '../../../../components/Fields/TextInput';
import { Fields } from '../../../../utils/Fields';
import Paragraph from '../../../../components/Typography/Paragraph';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import AvatarInput from '../../../../components/Fields/AvatarInput';
import { usePlaceholder } from '../../../../hooks/usePlaceholder';
var ProfessionalData = function () {
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var values = useOutletContext().values;
    var setValuesAndGoToNextStep = useWizard().setValuesAndGoToNextStep;
    var _b = useValidation(), textOptional = _b.textOptional, textRequired = _b.textRequired, emailRequired = _b.emailRequired, passwordRequired = _b.passwordRequired, passwordConfirmation = _b.passwordConfirmation, avatarRequired = _b.avatarRequired, passwordInstructions = _b.passwordInstructions;
    var placeholders = usePlaceholder();
    var schema = yup.object().shape({
        avatar: avatarRequired,
        last_name: textRequired,
        first_name: textRequired,
        artist_name: textOptional,
        email: emailRequired,
        password: passwordRequired,
        password_confirmation: passwordConfirmation('password'),
    });
    var _c = useForm({
        resolver: yupResolver(schema),
        defaultValues: __assign(__assign({}, values), { first_name: (values === null || values === void 0 ? void 0 : values.first_name) || searchParams.get('first_name') || '', last_name: (values === null || values === void 0 ? void 0 : values.last_name) || searchParams.get('last_name') || '', email: (values === null || values === void 0 ? void 0 : values.email) || searchParams.get('email') || '' }),
    }), handleSubmit = _c.handleSubmit, control = _c.control, setError = _c.setError;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axiosInstance.post(api.user.check, {
                            email: data.email,
                            artist_name: data.artist_name,
                        })];
                case 1:
                    response = _a.sent();
                    setValuesAndGoToNextStep(data);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    if (error_1.response) {
                        error_1.response.data.errors.forEach(function (error) {
                            Object.keys(error).forEach(function (key) {
                                setError(key, { message: error[key] });
                            });
                        });
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (<FadeIn>
      <div className="flex flex-col gap-10 py-10">
        <div>
          <Heading level={1} type="h4">
            S’inscrire sur Majeur·e·s
          </Heading>
          <Paragraph size="lg">Vos informations personnelles</Paragraph>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6">
            <FormRow className="justify-center">
              <AvatarInput name="avatar" control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Nom" type={Fields.TEXT} name="last_name" placeholder={placeholders.lastName} control={control} required/>
              <TextInput label="Prénom" type={Fields.TEXT} name="first_name" placeholder={placeholders.firstName} control={control} required/>
            </FormRow>
            <FormRow>
              <TextInput label="Nom d’artiste/Surnom" type={Fields.TEXT} name="artist_name" placeholder={placeholders.artistName} control={control} instructions="Indiquez le pseudonyme sous lequel on vous connaît le mieux."/>
            </FormRow>
            <FormRow>
              <TextInput label="Email" type={Fields.EMAIL} name="email" placeholder={placeholders.email} control={control} instructions="Choisissez un e-mail auquel vous aurez toujours accès (éviter les emails professionnels)" required/>
            </FormRow>
            <FormRow>
              <TextInput label="Mot de passe" type={Fields.PASSWORD} name="password" placeholder={placeholders.password} control={control} required instructions={passwordInstructions}/>
            </FormRow>
            <FormRow>
              <TextInput label="Confirmation du mot de passe" type={Fields.PASSWORD} name="password_confirmation" placeholder={placeholders.password} control={control} required/>
            </FormRow>
            <Button submit className="sm:self-end">
              Continuer
            </Button>
          </div>
        </form>
      </div>
    </FadeIn>);
};
export default ProfessionalData;
